import { Helmet } from 'react-helmet-async';
import { Navigate } from 'react-router-dom';

import { ApplicationList } from 'components/application-list';
import { Box } from 'components/box';
import { Breadcrumb, Breadcrumbs } from 'components/breadcrumbs';
import { LicenseAlertStack } from 'components/licensing-alerts';
import { useApplicationsQuery } from 'data/applications';

export const Applications = () => {
  const { applications } = useApplicationsQuery();

  if (applications.length === 1) {
    return <Navigate to={`/${applications[0].fullPath}`} />;
  } else if (new Set(applications.map((x) => x.organization.id)).size === 1) {
    return <Navigate to={`/orgs/${applications[0].organization.path}`} />;
  }

  return (
    <>
      <Helmet>
        <title>Applications</title>
      </Helmet>

      <Box container css={{ py: '$6' }}>
        <Breadcrumbs>
          <Breadcrumb>Home</Breadcrumb>
          <Breadcrumb>Applications</Breadcrumb>
        </Breadcrumbs>

        <LicenseAlertStack applicationCount={applications.length} marginBottom={8} />

        <ApplicationList applications={applications} />
      </Box>
    </>
  );
};
